import { render, staticRenderFns } from "./AddCostFactor.vue?vue&type=template&id=7d5f9aab&scoped=true&"
import script from "./AddCostFactor.vue?vue&type=script&lang=ts&"
export * from "./AddCostFactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f9aab",
  null
  
)

export default component.exports